module.exports = __webpack_public_path__ + "fallback.png";


//////////////////
// WEBPACK FOOTER
// /node_modules/file-loader/dist/cjs.js?name=fallback.png!./assets/images/sample@2x.png
// module id = OFr3
// module chunks = 0